import Appsignal from "@appsignal/javascript";
import config from "./config";

export const appsignal = new Appsignal({
  key: config.appsignal.apiKey,
  namespace: "frontend",
  revision: config.revision
});
